import * as React from "react";
const SvgFiRrFlask = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flask_svg__a)">
      <path
        fill="#062147"
        d="M17.929 9.891A3 3 0 0 1 17 7.721V2h1a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2h1v5.721a3 3 0 0 1-.929 2.169C3.804 12.039 0 16.19 0 19.857c0 .862.23 1.648.685 2.334C1.432 23.323 2.744 24 4.193 24h15.615c1.449 0 2.761-.676 3.507-1.808a4.16 4.16 0 0 0 .686-2.335c0-3.667-3.805-7.818-6.072-9.966m3.717 11.199c-.37.562-1.074.91-1.838.91H4.192c-.764 0-1.468-.349-1.839-.911a2.16 2.16 0 0 1-.354-1.232c0-.901.337-1.882.854-2.857h14.146a1 1 0 1 0 0-2H4.144c1.149-1.537 2.492-2.89 3.302-3.658A5 5 0 0 0 9 7.721V2h6v5.721c0 1.366.566 2.686 1.554 3.622C18.192 12.895 22 16.831 22 19.858c0 .469-.115.872-.354 1.232"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flask_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlask;
